import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authGuard } from './services/index';

import { AccountGuardService } from './services/guards/account-guard.service';
import { ourCeremonyToggleGuard } from './services/guards/feature-toggle.guard';
import { externalVenueAddOnsGuard } from './services/guards/external-venue-add-ons.guard';
import { environment } from '../environments/environment';
import { DatastoreService } from '../app/services';
import { AccessComponent } from './journey/access/access.component';
import { OurCeremonyComponent } from './journey/our-ceremony/our-ceremony.component';
import { ChecklistComponent } from './journey/checklist/checklist.component';
import { PaymentInformationComponent } from './journey/payment-information/payment-information.component';
import { MyAddOnsComponent } from './journey/my-add-ons/my-add-ons.component';
import { GiveNoticeComponent } from './journey/give-notice/give-notice.component';
import { CeremonyChoicesComponent } from './journey/ceremony-choices/ceremony-choices.component';
import { TermsAndConditionsComponent } from './journey/terms-and-conditions/terms-and-conditions.component';
import { FaqsComponent } from './journey/faqs/faqs.component';
import { CommunicationComponent } from './journey/communication/communication.component';
import { PaymentVerifyComponent } from './journey/payment-verify/payment-verify.component';
import { ActivatedRouteSnapshot } from '@angular/router';


const routes: Routes = [
	{
		path: 'myceremony',
		redirectTo: (routeData: ActivatedRouteSnapshot) => {
			let pathStr = '/404';
			if (Object.keys(routeData.queryParams).length > 0) {
				pathStr = `${pathStr}`;
				let i = 0;
				for (const param of Object.keys(routeData.queryParams)) {
					let sep = '?';
					if (i > 0) {
						sep = '&';
					}
					pathStr = `${pathStr}${sep}${param}=${routeData.queryParams[param]}`;
					i++;
				}
			}
			return pathStr;
		},
		pathMatch: 'full',
	},
	{
		path: ':site/:comp',
		redirectTo: ':site/:comp/access',
		pathMatch: 'full',
	},
	{
		path: ':site/:comp/access',
		component: AccessComponent,
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/our-ceremony',
		component: OurCeremonyComponent,
		canActivate: [authGuard],
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/ceremony-discussion',
		canActivate: [authGuard],
		loadComponent: () =>
			import(
				'./journey/ceremony-discussion/ceremony-discussion.component'
			).then((m) => m.CeremonyDiscussionComponent),
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/ceremony-checklist',
		component: ChecklistComponent,
		canActivate: [authGuard],
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/ceremony-enhancements',
		canActivate: [authGuard],
		loadComponent: () =>
			import('./journey/enhancements/enhancements.component').then(
				(m) => m.EnhancementsComponent
			),
	},
	{
		path: ':site/:comp/payment-information',
		component: PaymentInformationComponent,
		canActivate: [authGuard],
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/optional-add-ons',
		component: MyAddOnsComponent,
		canActivate: [
			authGuard,
			ourCeremonyToggleGuard('can_purchase_addons'),
			externalVenueAddOnsGuard,
		],
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/give-notice',
		component: GiveNoticeComponent,
		canActivate: [authGuard],
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/ceremony-choices',
		component: CeremonyChoicesComponent,
		canActivate: [authGuard],
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/terms-and-conditions',
		component: TermsAndConditionsComponent,
		canActivate: [authGuard],
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/faqs',
		component: FaqsComponent,
		canActivate: [authGuard],
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/communication',
		component: CommunicationComponent,
		canActivate: [authGuard],
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/verify/:paymentType',
		component: PaymentVerifyComponent,
		canActivate: [authGuard],
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/cancel',
		canActivate: [authGuard, ourCeremonyToggleGuard('can_cancel')],
		loadChildren: () =>
			import('./journey/cancel/cancel.module').then((m) => m.CancelModule),
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/extend',
		canActivate: [authGuard, ourCeremonyToggleGuard('can_extend')],
		loadChildren: () =>
			import('./journey/extend/extend.module').then((m) => m.ExtendModule),
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/reschedule',
		canActivate: [authGuard, ourCeremonyToggleGuard('can_reschedule')],
		loadChildren: () =>
			import('./journey/reschedule/reschedule.module').then(
				(m) => m.RescheduleModule
			),
		data: {
			breadcrumb: '',
		},
	},
	{
		path: ':site/:comp/add-ons',
		canActivate: [
			authGuard,
			ourCeremonyToggleGuard('can_purchase_addons'),
			externalVenueAddOnsGuard,
		],
		loadChildren: () =>
			import('./journey/add-ons/add-ons.module').then((m) => m.AddOnsModule),
		data: {
			breadcrumb: '',
		},
	},
	{
		path: '404',
		loadChildren: () => {
			return import('./404/four-oh-four.module').then(
				(m) => m.FourOhFourModule
			);
		},
		data: {},
	},
	{
		path: ':site/:comp/404',
		loadChildren: () => {
			return import('./404/four-oh-four.module').then(
				(m) => m.FourOhFourModule
			);
		},
		data: {},
	},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private dataStore: DatastoreService) {}
}
